import ButtonComp from "themes/elements/Button";

function ApprovalBtn(props) {
  const { onEdit, setReject, setApprove, selectedNews } = props;
  return (
    <>
      <ButtonComp variant="secondary" onClick={() => onEdit(selectedNews)}>
        Edit
      </ButtonComp>
      <ButtonComp variant="secondary" onClick={() => setReject(true)}>
        Reject
      </ButtonComp>
      <ButtonComp onClick={() => setApprove(true)}>Approve</ButtonComp>
    </>
  );
}

export default ApprovalBtn;
